import React, { useState } from 'react';
import { FilterIcon, XIcon, ChevronDownIcon } from 'lucide-react';
import { ActiveFilter } from '../types/filters';
interface FilterBarProps {
  activeFilters: ActiveFilter[];
  onRemoveFilter: (filterId: string) => void;
  onOpenFilters: () => void;
}
export function FilterBar({
  activeFilters,
  onRemoveFilter,
  onOpenFilters
}: FilterBarProps) {
  if (activeFilters.length === 0) {
    return <button onClick={onOpenFilters} className="flex items-center px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors text-sm" data-id="element-520">
        <FilterIcon size={16} className="mr-2" data-id="element-521" />
        Filters
      </button>;
  }
  return <div className="flex items-center space-x-2" data-id="element-522">
      <button onClick={onOpenFilters} className="flex items-center px-4 py-2 border border-blue-500 bg-blue-50 rounded-md text-blue-700 hover:bg-blue-100 transition-colors text-sm font-medium" data-id="element-523">
        <FilterIcon size={16} className="mr-2" data-id="element-524" />
        Filters ({activeFilters.length})
      </button>

      <div className="flex items-center space-x-2 flex-wrap" data-id="element-525">
        {activeFilters.map(filter => <div key={filter.filterId} className="flex items-center px-3 py-1.5 bg-blue-100 border border-blue-300 rounded-md text-sm" data-id="element-526">
            <span className="text-blue-900 font-medium mr-2" data-id="element-527">
              {filter.label}:
            </span>
            <span className="text-blue-700" data-id="element-528">{filter.value}</span>
            <button onClick={() => onRemoveFilter(filter.filterId)} className="ml-2 text-blue-600 hover:text-blue-800 transition-colors" data-id="element-529">
              <XIcon size={14} data-id="element-530" />
            </button>
          </div>)}
      </div>
    </div>;
}